import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { isFlagOn } from 'utils/featureFlags'
import {
  DateText,
  EditButton,
  GoalContentHeaderWrapper,
  GoalContentWrapper,
  GoalSubTitle,
  GoalText,
  StyledDateRange,
  StyledEditIcon,
  StyledGoalHr,
} from '../component.styles'
import { BTS_2026_FLAG, EDIT_BUTTON_TEST_ID } from '../constants'
import { formatShortDate } from '../goalHelpers'

const CustomGoal = ({
  goalDate,
  goalText,
  isSingleSite,
  onOpenGoalsModal,
  programStartDate,
  showHeader,
  showMonitorViewOnly,
}) => {
  const endDateInMs = new Date(goalDate).getTime()
  const programStartDateInMs = new Date(programStartDate).getTime()

  return (
    <GoalContentWrapper
      isSingleSite={isSingleSite}
      selectedGoalIsCompleted={true}
      showHeader={showHeader}
      showMonitorViewOnly={showMonitorViewOnly}
    >
      <GoalContentHeaderWrapper>
        {!programStartDate && (
          <DateText>Target Date: {formatShortDate(goalDate)}</DateText>
        )}
        {programStartDate && (
          <StyledDateRange
            endDateInMs={endDateInMs}
            endDateTextFormatted={formatShortDate(goalDate)}
            progressBarView={true}
            startDateInMs={programStartDateInMs}
            startDateTextFormatted={formatShortDate(programStartDate)}
          />
        )}
        {isFlagOn([BTS_2026_FLAG]) && (
          <EditButton
            data-testid={EDIT_BUTTON_TEST_ID}
            onClick={onOpenGoalsModal}
          >
            <StyledEditIcon aria-label="Edit Goals" />
          </EditButton>
        )}
      </GoalContentHeaderWrapper>
      <StyledGoalHr showMonitorViewOnly={showMonitorViewOnly} />
      <Fragment key="custom-goal-content">
        <GoalSubTitle>Custom Goal</GoalSubTitle>
        <GoalText selectedGoalIsCompleted={true}>{goalText}</GoalText>
      </Fragment>
    </GoalContentWrapper>
  )
}

CustomGoal.propTypes = {
  goalDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  goalText: PropTypes.string,
  isCompleted: PropTypes.bool,
  isSingleSite: PropTypes.bool,
  onOpenGoalsModal: PropTypes.func,
  programStartDate: PropTypes.number,
  showHeader: PropTypes.bool,
  showMonitorViewOnly: PropTypes.bool,
  sitePlaybookData: PropTypes.object,
}

export default CustomGoal
